import { render, staticRenderFns } from "./practicalActivityEdit.vue?vue&type=template&id=278f2281&scoped=true"
import script from "./practicalActivityEdit.vue?vue&type=script&lang=js"
export * from "./practicalActivityEdit.vue?vue&type=script&lang=js"
import style0 from "./practicalActivityEdit.vue?vue&type=style&index=0&id=278f2281&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278f2281",
  null
  
)

export default component.exports